// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { DivWrapper } from "@steiner/XDL/constants";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

interface CheckoutPageContainerStyles {
    container?: InjectableCss;
    leftSection?: InjectableCss;
    rightSection?: InjectableCss;
}

const checkoutPageContainerStyles: CheckoutPageContainerStyles = {
    container: {
        css: css`
            width: 100%;

            display: grid;
            grid-template-columns: 1fr 317px;
            grid-template-rows: auto;
            gap: 32px 22px;
            ${xScreen("lte", "md")} {
                grid-template-columns: auto;
            }
        `,
    },
    leftSection: {
        css: css`
            grid-area: 1 / 1 / 2 / 2;
        `,
    },
    rightSection: {
        css: css`
            grid-area: 1 / 2 / 2 / 3;
            ${xScreen("lte", "md")} {
                max-width: initial;
                grid-area: 2 / 1 / 3 / 2;
            }

            & > ${DivWrapper} {
                height: 100%;
            }
        `,
    },
};

export default checkoutPageContainerStyles;
